module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8r3n6n-2f1c243a06e4dacb44035c39e8e60277.svg";